import CheckBoxField from "../CheckBoxField";
import TextField from "../TextField";

type Props = {
  handleChange: (attr: string) => (evt: React.ChangeEvent) => void;
  onSubmit: (evt: React.MouseEvent) => Promise<void>;
  validateData: (state: Partial<BidsRegistration.Data>) => boolean;
  state: BidsRegistration.Data;
  strings: BidsRegistration.Localizations;
};

export default function PhoneBidForm(props: Props) {
  const formStrings = props.strings.phone_bid;
  const labels = props.strings.labels.phone_bid;

  const textField = (
    attr: keyof BidsRegistration.Data,
    additionalProps = {}
  ) => {
    return (
      <TextField
        {...additionalProps}
        prefix="phone_bid_registration"
        name={attr}
        label={labels[attr]}
        onChange={props.handleChange(attr)}
        value={props.state[attr] as string}
      />
    );
  };

  const handleSubmit = (evt: React.MouseEvent) => {
    void props.onSubmit(evt);
  };

  return (
    <form>
      <div
        className="intro"
        dangerouslySetInnerHTML={{ __html: formStrings.intro_html }}
      />
      {textField("name")}
      {textField("email", { type: "email" })}
      {textField("phone")}
      <div
        className="billing-info"
        dangerouslySetInnerHTML={{ __html: formStrings.billing_info_html }}
      />
      {textField("billing_name", { placeholder: props.state.name })}
      {textField("billing_address")}
      {textField("billing_postal_code")}
      {textField("billing_postal_area")}
      {textField("billing_country")}
      <CheckBoxField
        prefix="phone_bid_registration"
        name="accept_conditions"
        label={labels["accept_conditions_html"]}
        onChange={props.handleChange("accept_conditions")}
        value={props.state["accept_conditions"]}
      />
      <CheckBoxField
        prefix="phone_bid_registration"
        name="consent"
        label={labels["consent"]}
        onChange={props.handleChange("consent")}
        value={props.state["consent"]}
      />
      <button
        disabled={!props.validateData(props.state)}
        type="submit"
        onClick={handleSubmit}
        className="submit-button">
        {formStrings.button_label}
      </button>
    </form>
  );
}
